import React, { useRef } from "react";
import { Dropdown, Card, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";

// Importing redux components
import { useSelector } from "react-redux";

// Import default profile picture
import profilePic from "assets/images/profile.jpg";

// Importing validators
import { isNull } from "validations";

const Employee = ({
  isAllowedToUpdate,
  isAllowedToDelete,
  employee,
  deleteEmployee,
  handleEdit,
}) => {
  const { userInfo: loggedUserInfo } = useSelector((state) => state.auth);

  return (
    <Card className="all-em-card">
      <div className="all-e-img">
        <NavLink
          className="img-placeholder"
          to={`/employee/${employee?.employeeId}`}
        >
          <Image
            src={
              employee?.biometricDetails?.profilePicture && !isNull(employee?.biometricDetails?.profilePicture)
                ? employee.biometricDetails.profilePicture
                : profilePic
            }
            onError={e => {
              e.target.src = profilePic;
            }}
            className="img-fluid"
            alt="Profile"
          />
        </NavLink>
        <h5 className="card-title">
          <NavLink
            to={`/employee/${employee?.employeeId}`}
            className={loggedUserInfo?.id !== employee?.id ? "" : "me-2"}
          >
            {employee?.name}
          </NavLink>
          {loggedUserInfo?.id === employee?.id && "(You)"}
        </h5>
        <p className="mb-0">
          <span>{employee?.designation?.name}</span>
          {" | "}
          <span>{employee?.team?.name}</span>
        </p>
      </div>
      {(isAllowedToUpdate || isAllowedToDelete) && (
        <div className="filter">
          <Dropdown align={{ lg: "end" }}>
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <i className="bi bi-three-dots"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {isAllowedToUpdate &&
                (loggedUserInfo?.id === employee?.id ? (
                  <Dropdown.Item as={NavLink} to="/profile">
                    <i className="bi bi-pencil-square"></i>
                    Edit
                  </Dropdown.Item>
                ) : (
                  <Dropdown.Item onClick={() => handleEdit(employee)}>
                    <i className="bi bi-pencil-square"></i>
                    Edit
                  </Dropdown.Item>
                ))}
              {isAllowedToDelete && (
                <Dropdown.Item onClick={() => deleteEmployee(employee?.id)}>
                  <i className="bi bi-trash3"></i>
                  Delete
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
    </Card>
  );
};

export default Employee;
